<template>
    <toolbar-option>
        <template slot="primary">
            <input
                v-model="value"
                type="text"
                :class="{ 'is-invalid': !isValid }"
                @change="setChangedData(true)"
            >
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

export default {
    name: 'input-name',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Input Name',
            value: '',
        };
    },

    watch: {
        value() {
            this.selectedElements[0].inputNameNew = this.value;
            this.onOptionChange(this.value);
        },
    },

    created() {
        this.validateOption(this.value);
    },

    methods: {
        onSelectedElement() {
            this.value = this.selectedElements[0].inputNameNew;
        },
    },
};
</script>
